import { InputHTMLAttributes, useEffect, useRef } from 'react'
import Checkbox from '@mui/material/Checkbox'
import { classNames } from 'src/lib/utils/helpers'

export type CheckboxValue = boolean | 'indeterminate'

export default function CheckboxInput({
  checked,
  label,
  id,
  onChange,
  className
}: Readonly<{
  checked: CheckboxValue
  label: string
  id: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  className: string
}> &
  Omit<InputHTMLAttributes<HTMLInputElement>, 'checked'>) {
  return (
    <div className='checkbox flex items-center gap-1'>
      <Checkbox
        id={id}
        indeterminate={checked === 'indeterminate'}
        checked={checked === true || checked === false ? checked : false}
        size='small'
        sx={{
          height: '18px',
          width: '18px'
        }}
        onChange={onChange}
      />
      <label
        htmlFor={id}
        onClick={e => {
          e.stopPropagation()
        }}
        className={classNames('cursor-pointer text-sm', className)}
      >
        {label}
      </label>
    </div>
  )
}
